import { createRoutine } from "redux-saga-routines";

const ChangeLanguage = createRoutine("CHANGE_LANGUAGE");
const Reset = createRoutine("RESET");
const UploadFile = createRoutine("UPLOAD_FILE");
const GetUnits = createRoutine("GET_UNITS");
const SetToolbarTitle = createRoutine("SET_TOOLBAR_TITLE");
const GetStorages = createRoutine("GET_STORAGES");
const GetPaymentTypes = createRoutine("GET_PAYMENT_TYPES");

const GetOrganizations = createRoutine("GET_ORGANIZATIONS");
const SetMainStorage = createRoutine("SET_MAIN_STORAGE");
const ToggleOrganizationModal = createRoutine("TOGGLE_ORGANIZATION_MODAL");
const SetLangCodes = createRoutine("SET_LANG_CODES");

export default {
  GetStorages,
  GetOrganizations,
  GetUnits,
  ChangeLanguage,
  Reset,
  UploadFile,
  SetToolbarTitle,
  SetMainStorage,
  ToggleOrganizationModal,
  GetPaymentTypes,
  SetLangCodes,
};
